/**
 * Placeholder used by workflow agent-node message templates to reference the
 * runtime input supplied at execute time (see Composer default agent message).
 */
export const WORKFLOW_INPUT_PLACEHOLDER = '{{input}}';

/**
 * Returns true when the workflow graph JSON references the `{{input}}`
 * placeholder, meaning the workflow expects a runtime input value to be
 * provided when it is executed.
 */
export const workflowRequiresInput = (workflowJson: string | null | undefined): boolean =>
  !!workflowJson && workflowJson.includes(WORKFLOW_INPUT_PLACEHOLDER);
